export interface SessionStoredValue {
    get: () => string | null;
    set: (value: string | null) => void;
    subscribe: (listener: () => void) => () => void;
}

const stores = new Map<string, SessionStoredValue>();

export function createSessionStoredValue(key: string): SessionStoredValue {
    const cached = stores.get(key);

    if (cached) {
        return cached;
    }

    const listeners = new Set<() => void>();
    let inMemoryValue: string | null = null;
    let storageWriteFailed = false;

    function get(): string | null {
        if (storageWriteFailed) {
            return inMemoryValue;
        }

        try {
            return sessionStorage.getItem(key);
        } catch {
            return inMemoryValue;
        }
    }

    function set(value: string | null) {
        inMemoryValue = value;

        try {
            if (value !== null) {
                sessionStorage.setItem(key, value);
            } else {
                sessionStorage.removeItem(key);
            }
            storageWriteFailed = false;
        } catch {
            storageWriteFailed = true;
        }

        listeners.forEach(listener => listener());
    }

    function subscribe(listener: () => void): () => void {
        listeners.add(listener);

        return () => {
            listeners.delete(listener);
        };
    }

    const store = { get, set, subscribe };

    stores.set(key, store);

    return store;
}
